

import { Action } from '@ngrx/store';
import { ReportType } from 'src/app/shared/models';

import { CopyDefaultAdvicesResponse } from '../models/cop-default-advice-response.model';

export enum OverviewActionTypes {
  CreateAdviceReport = '[Overview] Create advice report',
  OpenDefaultReport = '[Overview] Open default report',
  OpenFertilizationSplitFields = '[Overview] Open fertilization split fields report',
  OpenFertilizationTableReport = '[Overview] Open fertilization table report',
  OpenLegalStandards = '[Overview] Open legal standards',
  OpenSkalReport = '[Overview] Open skal report',
  OpenOrganicMatterReport = '[Overview] Open organic matter report',
  OpenNutrientBalanceReport = '[Overview] Open nutrient balance report',
  OpenEnvironmentalImpactReport = '[Overview] Open environmental impact report',
  OpenPlanetProofReport = '[Overview] Open planet proof report',
  DeleteCropField = '[Overview][API] Delete Crop field',
  DeleteMultipleCropFields = '[Overview][API] Delete Multiple Crop fields',
  CopyDefaultCropCareAdvice = '[Overview][API] Copy Default Crop Care Advice',
  CopyDefaultFertilizationAdvice = '[Overview][API] Copy Default Fertilization Advice',
  CopyDefaultAdvicesSuccess = '[Overview][API] Copy Default Crop Care Advice Success',
}

export class CreateAdviceReport implements Action {
  readonly type = OverviewActionTypes.CreateAdviceReport;
}

export class OpenDefaultReport implements Action {
  readonly type = OverviewActionTypes.OpenDefaultReport;

  constructor(
    public readonly reportType:
      | ReportType.Fertilization
      | ReportType.GBMWithEnvironmentalImpactPoints,
  ) {}
}

export class OpenFertilizationSplitFields implements Action {
  readonly type = OverviewActionTypes.OpenFertilizationSplitFields;
}

export class OpenFertilizationTableReport implements Action {
  readonly type = OverviewActionTypes.OpenFertilizationTableReport;
}

export class OpenLegalStandards implements Action {
  readonly type = OverviewActionTypes.OpenLegalStandards;
}

export class OpenSkalReport implements Action {
  readonly type = OverviewActionTypes.OpenSkalReport;
}

export class OpenOrganicMatterReport implements Action {
  readonly type = OverviewActionTypes.OpenOrganicMatterReport;
}

export class OpenNutrientBalanceReport implements Action {
  readonly type = OverviewActionTypes.OpenNutrientBalanceReport;
}

export class OpenEnvironmentalImpactReport implements Action {
  readonly type = OverviewActionTypes.OpenEnvironmentalImpactReport;
}

export class OpenPlanetProofReport implements Action {
  readonly type = OverviewActionTypes.OpenPlanetProofReport;
}

export class DeleteMultipleCropFields implements Action {
  readonly type = OverviewActionTypes.DeleteMultipleCropFields;
  constructor(public readonly cropFieldId: number[]) {}
}

export class CopyDefaultCropCareAdvice implements Action {
  readonly type = OverviewActionTypes.CopyDefaultCropCareAdvice;
  constructor(public readonly customerId: number) {}
}

export class CopyDefaultFertilizationAdvice implements Action {
  readonly type = OverviewActionTypes.CopyDefaultFertilizationAdvice;
  constructor(public readonly customerId: number) {}
}

export class CopyDefaultAdviceSuccess implements Action {
  readonly type = OverviewActionTypes.CopyDefaultAdvicesSuccess;
  constructor(
    public readonly advices: CopyDefaultAdvicesResponse,
  ) {}
}

// export the combined type of all actions
export type OverviewActions =
  | CreateAdviceReport
  | OpenDefaultReport
  | OpenFertilizationTableReport
  | OpenLegalStandards
  | OpenSkalReport
  | OpenOrganicMatterReport
  | OpenNutrientBalanceReport
  | OpenEnvironmentalImpactReport
  | OpenPlanetProofReport
  | DeleteMultipleCropFields
  | CopyDefaultCropCareAdvice
  | CopyDefaultAdviceSuccess;
